/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { endpoints } from '../../config';
import './ShapeError.css';
import getCurrentOrganizationId from '../../utils/getCurrentOrganizationId';

export function ShapeErrorComponent() {
  const env = process.env.REACT_APP_API || 'local';
  const orgId = getCurrentOrganizationId();
  const { adminUrl, organizationEndPoint, viewerEndPoint } = endpoints[env];
  const infoUrl = `${adminUrl}${organizationEndPoint}/${orgId}${viewerEndPoint}/layers`;

  return (
    <div className="shapeError">
      <p>This organization's shape file may be inaccurate.
        Click <a href={infoUrl}>here</a> for more info.</p>
      <div className="shapeErrorClose">X</div>
    </div>
  );
}

export default ShapeErrorComponent;



// WEBPACK FOOTER //
// ./src/components/ShapeError/ShapeError.js